import { cn } from "@/lib/utils";
import type { UserRecordTab, UserRecordTabId } from "./user-record-tabs";

interface UserRecordTabListProps {
  tabs: UserRecordTab[];
  activeId: UserRecordTabId;
  onSelect: (id: UserRecordTabId) => void;
  badges?: Partial<Record<UserRecordTabId, number>>;
}

export function UserRecordTabList({
  tabs,
  activeId,
  onSelect,
  badges,
}: UserRecordTabListProps) {
  return (
    <nav
      className="flex flex-wrap border-b border-surfaces-divider"
      aria-label="User record sections"
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeId;
        const badge = badges?.[tab.id] ?? 0;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onSelect(tab.id)}
            className={cn(
              "inline-flex h-12 items-center px-4 font-body text-base leading-5",
              isActive
                ? "-mb-px border-b-[1.5px] border-[#8a8275] font-bold text-text-primary"
                : "font-normal text-text-tertiary hover:text-text-primary",
            )}
          >
            {tab.label}
            {badge > 0 ? (
              <span className="ml-2 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-[#f93b51] px-1 font-body text-[11px] leading-4 text-white">
                {badge}
              </span>
            ) : null}
          </button>
        );
      })}
    </nav>
  );
}
